// src/ForcePasswordChangeModal.js - NUOVO FILE

import React, { useState } from 'react';
import { useUser } from './UserContext';
import { auth, db } from './firebase';
import { updatePassword } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";

// Stili per rendere il modale a schermo intero
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(242, 242, 242, 0.95)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
};

const modalContentStyle = {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
};

export function ForcePasswordChangeModal({ onPasswordChanged }) {
    const { userProfile } = useUser();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSavePassword = async () => {
        setError('');
        if (!newPassword || !confirmPassword) {
            setError('Entrambi i campi sono obbligatori.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Le password non coincidono.');
            return;
        }
        if (newPassword.length < 6) {
            setError('La password deve essere di almeno 6 caratteri.');
            return;
        }

        setIsLoading(true);
        const user = auth.currentUser;

        const { centerId } = userProfile;

    if (!centerId) {
        console.error("Errore: centerId non trovato nel profilo utente.");
        setError('Impossibile salvare. Dati del centro non trovati.');
        setIsLoading(false);
        return;
    }

        try {
            // 1. Aggiorna la password in Firebase Authentication
            await updatePassword(user, newPassword);

            // 2. Aggiorna il flag nel documento Firestore dell'utente
        const userDocRef = doc(db, 'centers', centerId, 'staff', user.uid); // <-- MODIFICA QUI
            await updateDoc(userDocRef, {
                forcePasswordChange: false
            });

            // 3. Comunica al resto dell'app che il cambio è avvenuto
            alert('Password aggiornata con successo! Ora puoi accedere all\'applicazione.');
            onPasswordChanged();

        } catch (error) {
            console.error("Errore durante l'aggiornamento della password:", error);
            setError('Si è verificato un errore. Riprova.');
            setIsLoading(false);
        }
    };

    return (
        <div style={modalOverlayStyle}>
            <div style={modalContentStyle}>
                <h3>Cambia la tua Password</h3>
                <p>Ciao {userProfile.name}, per motivi di sicurezza, imposta una nuova password personale.</p>
                
                <div style={{ textAlign: 'left', margin: '20px 0' }}>
                    <label htmlFor="new-password">Nuova Password</label>
                    <input
                        id="new-password"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
                    />
                </div>
                <div style={{ textAlign: 'left', marginBottom: '20px' }}>
                    <label htmlFor="confirm-password">Conferma Nuova Password</label>
                    <input
                        id="confirm-password"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
                    />
                </div>

                {error && <p style={{ color: 'red' }}>{error}</p>}

                <button 
                    onClick={handleSavePassword} 
                    disabled={isLoading} 
                    className="modal-button confirm-button"
                    style={{width: '100%'}}
                >
                    {isLoading ? 'Salvataggio...' : 'Salva Nuova Password'}
                </button>
            </div>
        </div>
    );
}